import {ContractsProvider} from './../../providers/api/contracts.provider';
import {Conversion, DealStatus, ShopOrderStatus, User} from './../../models/models';
import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ToastController} from 'ionic-angular';
import { UserAuthProvider } from '../../modules/mrk-user-auth/user-auth';
import { filter, map, take } from 'rxjs/operators'

/**
* Generated class for the ContractDetailPage page.
*
* See https://ionicframework.com/docs/components/#navigation for more info on
* Ionic pages and navigation.
*/

@IonicPage()
@Component({
  selector: 'page-contract-detail',
  templateUrl: 'contract-detail.html',
})
export class ContractDetailPage {

  contract: Conversion = null
  isShopOrderPaid: boolean = false
  parent = null

  DealStatus = DealStatus
  name: string

  constructor(public navCtrl: NavController,
     public navParams: NavParams,
      private readonly contractsProvider: ContractsProvider,
       private readonly toastCtrl: ToastController,
       userProvider: UserAuthProvider<User>) {
    if (typeof navParams.get('contract') != 'undefined') {
      this.contract = navParams.get('contract')
      this.isShopOrderPaid = this.contract.deal.shop_orders.length &&
        this.contract.deal.shop_orders[this.contract.deal.shop_orders.length - 1].status === ShopOrderStatus.COMPLETED
    }
    this.parent = (navParams && navParams.get('parent')) || null

    userProvider.userState.pipe(
      filter(state => state.logged),
      take(1),
      map(state => `${state.user.firstname} ${state.user.surname}` )
      ).subscribe( name => {
        this.name = name
      })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ContractDetailPage');
  }

  conversionLost(){
    const conversionId = this.contract.id
    this.contractsProvider.setAslost(conversionId).subscribe(
      deal => {
        this.contract.deal = deal
        this.notifyOk()
      },
      _e => {
        this.notifyError()
      }
    )
  }

  notifyOk() {
    this.toastCtrl.create({
      message: 'Operazione conclusa con successo',
      duration: 2000,
      position: 'top'
    }).present()
    this.parentRefresh()
  }

  notifyError(e: string = "") {
    this.toastCtrl.create({
      message: 'Si è verificato un errore ' + e,
      duration: 2000,
      position: 'top'
    }).present()
    this.parentRefresh()
  }

  parentRefresh() {
    this.parent && this.parent.refresh && this.parent.refresh()
  }

  finalizeContract() {
    let finalizeUrl = "https://admin.mypushop.com/contract/finalization/" + this.contract.deal.id + "/"
    var win = window.open(finalizeUrl, '_blank')
    win.focus()
  }
}



// WEBPACK FOOTER //
// ./src/pages/contract-detail/contract-detail.ts